import { render, staticRenderFns } from "./CookiesPrivacyPolicyTerms.vue?vue&type=template&id=3a80b0d7&"
import script from "./CookiesPrivacyPolicyTerms.vue?vue&type=script&lang=js&"
export * from "./CookiesPrivacyPolicyTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports